import React from 'react';

const DataTableRow = (props) => {
    let columnClasses = 'cell';
    let columnClicked = null;

    const columnsData = props.columns.map((c, colIndex) => {
        if (c.columnClickHandler) {
            columnClasses += ' clickable';
            columnClicked = c.columnClickHandler.bind(this, props.data);
        }
        if (c.wrapText) {
            columnClasses += ' wrap-text';
        }
        if (c.capitalize) {
            columnClasses += ' capitalize';
        }

        return (
            <React.Fragment key={colIndex}>
                <td className={columnClasses} onClick={columnClicked}>
                    {c.columnRenderer ? c.columnRenderer(props.data[c.accessor], props.data[c.extra_data]) : props.data[c.accessor]}
                </td>
                <td></td>
                <td></td>
            </React.Fragment>
        );
    });

    return (
        <tr>
            <td></td>
            {columnsData}
            <td></td>
        </tr>
    );
};

export default DataTableRow;
